var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal"},[_c('left',{ref:"left",staticStyle:{"width":"220px","margin-right":"40px"}}),_c('div',{staticClass:"right"},[_c('rightTop'),_c('router-view',{staticClass:"rightContentss"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }